
<div class="links">
    {{content}}
    <a *ngIf="!isContentToggled" (click)="toggleContent()">Read More</a>  
    <a *ngIf="isContentToggled" (click)="toggleContent()">Read Less</a>

</div>
